import { render, staticRenderFns } from "./LicenseAgreementModal.vue?vue&type=template&id=226d6812&scoped=true"
import script from "./LicenseAgreementModal.vue?vue&type=script&lang=js"
export * from "./LicenseAgreementModal.vue?vue&type=script&lang=js"
import style0 from "./LicenseAgreementModal.vue?vue&type=style&index=0&id=226d6812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226d6812",
  null
  
)

export default component.exports